import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BuyerSupplierService } from '../../../services/buyer-supplier.service';
import { ToastrService } from 'ngx-toastr';
import { PrBuyerHelperService } from '../../../services/pr-buyer-helper.service';
import { IAPIResponse } from 'src/app/modules/shared/models';

@Component({
  selector: 'app-deligation',
  templateUrl: './deligation.component.html',
  styleUrls: ['./deligation.component.scss']
})
export class DeligationComponent implements OnInit {

  public title !: string;
  public prData !: any;
  public enterEmailForm !: FormGroup;
  @ViewChild('form') form: any;

  constructor(private _formBuilder: FormBuilder,
    public bsModalRef: BsModalRef,
    private _buyerSupplierService: BuyerSupplierService,
    private _toastrService: ToastrService,
    private _buyerHelperService: PrBuyerHelperService
    ) {
      this.enterEmailForm = this._formBuilder.group({
        email: [null, [Validators.required]]
      });
     }

  ngOnInit(): void {
  }

  public onModalClose(): void {
    this.bsModalRef.hide();
  }

  public emailEntered() {
    const body: any = {
      "prId": this.prData[0]?.prId,
      "user_email":this.enterEmailForm.getRawValue().email
    };
    this._buyerSupplierService.prAssignedToAnotherManager(body).subscribe((res: IAPIResponse<any>) => {
      this._toastrService.success(res.message);
      this.onModalClose();
    }, err =>{
        this.onModalClose();
    });
    this.form.resetForm();
  }

}
